// src/pages/ProfilePage/RoleSelectModal.js
import React from "react";
import styles from "./RoleSelectModal.module.scss";

export const CURRENT_APP_ACTION_CODE = "__CURRENT_APP__";

const RoleSelectModal = ({
    open,
    onClose,
    onSelect,
    availableRoles,
    currentAppRoleCodes = [],
    currentAppStayLabel = "Остаться в текущем приложении",
}) => {
    if (!open) return null;

    const rolesWithoutCurrentApp = (availableRoles || []).filter(
        (role) => !currentAppRoleCodes.includes(role.code)
    );

    const canSwitchRole = rolesWithoutCurrentApp.length > 0;

    const getButtonText = (roleName) => `Открыть как ${roleName}`;

    return (
        <div className={styles.overlay} onClick={onClose}>
            <div
                className={styles.modal}
                role="dialog"
                aria-modal="true"
                onClick={(event) => event.stopPropagation()}
            >
                <h2 className={styles.title}>Выберите роль</h2>

                <div className={styles.buttonGroup}>
                    {canSwitchRole && (
                        <button className={styles.roleBtn} onClick={() => onSelect(CURRENT_APP_ACTION_CODE)}>
                            {currentAppStayLabel}
                        </button>
                    )}

                    {rolesWithoutCurrentApp.map((role) => (
                        <button key={role.code} className={styles.roleBtn} onClick={() => onSelect(role.code)}>
                            {getButtonText(role.name)}
                        </button>
                    ))}
                </div>

                <button className={styles.cancelBtn} onClick={onClose}>
                    Отмена
                </button>
            </div>
        </div>
    );
};

export default RoleSelectModal;
